import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutService } from '../../services/checkout/checkout.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tok-complete-modal',
  templateUrl: './tok-complete-modal.component.html',
  styleUrls: ['./tok-complete-modal.component.scss'],
})
export class TokCompleteModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal, private checkoutService: CheckoutService) {}

  ngOnInit(): void {}

  public buyTok() {
    this.checkoutService.checkout([environment.stripePlans.identiAlertTokBreeder]).subscribe(
      () => {},
      (err) => {}
    );
  }
}
